/**
 * What each first-party tool is for, in the words the model reads. The action schemas live
 * in apps/shared/tools.ts; this metadata is here so the charter (a domain concern) can
 * describe the tools without importing application code.
 */
export type ToolId = "notes" | "tasks" | "calendar";
export const TOOL_META: Record<ToolId, { title: string; summary: string; whenToUse: string }> = {
  notes: {
    title: "Notes",
    summary: "Private notes saved in your account.",
    whenToUse: "Free text the person wants kept for later: ideas, decisions, information to remember.",
  },
  tasks: {
    title: "Tasks",
    summary: "Things to do, with due dates, reminders and recurrence.",
    whenToUse: "Something the person wants done, followed up or be reminded about, optionally by a date or on a schedule. A reminder arrives as a message in Delegate.",
  },
  calendar: {
    title: "Calendar",
    summary: "Appointments and events, with reminders.",
    whenToUse: "An appointment, meeting or event at a date and time (or an all-day date). A reminder arrives as a message in Delegate.",
  },
};
/** The one honest sentence about delivery; nothing is emailed or pushed. */
export const REMINDER_DELIVERY = "Reminders arrive as messages in Delegate; nothing is emailed or pushed.";
/** The charter block for the tools an avatar holds (empty when it holds none). */
export function toolsGuidance(tools: readonly ToolId[]): string {
  if (!tools.length) return "";
  const lines = tools.map((id) => `- ${TOOL_META[id].title}: ${TOOL_META[id].whenToUse}`);
  return `\nTOOLS YOU CAN USE WITH THE PERSON (they open on the person's screen as you use them):\n${lines.join("\n")}\n${REMINDER_DELIVERY} Give times as ISO with the person's timezone. Read a record's revision before changing it; on a conflict, read again and ask.`;
}
